import CacheStore from 'bz-utilities/modules/stores/cached-map-store';
import { computed } from 'mobx';
import { createTransformer } from 'mobx-utils';
import type { Tag } from 'tm3-core/api.dtos';

class TagsStore extends CacheStore<Tag> {
  constructor() {
    super('tags');
  }
  @computed
  get Current() {
    return this.All.filter((x) => x.isActive);
  }
}
export default TagsStore;
